// ConciergeBanner - Prominent entry point for the AI Concierge

import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';

interface ConciergeBannerProps {
  onClick: () => void;
  realm?: 'goodlife' | 'goodwork';
}

export function ConciergeBanner({ onClick, realm = 'goodlife' }: ConciergeBannerProps) {
  const isGoodWork = realm === 'goodwork';

  return (
    <button
      onClick={onClick}
      className="
        w-full p-4 mb-6
        bg-gradient-to-r from-indigo-500 via-purple-500 to-indigo-600
        rounded-2xl shadow-lg
        flex items-center gap-4
        hover:from-indigo-600 hover:via-purple-600 hover:to-indigo-700
        transition-all hover:shadow-xl hover:scale-[1.01]
        text-left
      "
    >
      {/* Icon */}
      <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
        <Sparkles className="w-6 h-6 text-white" />
      </div>

      {/* Text */}
      <div className="flex-1 min-w-0">
        <h3 className="text-white font-semibold text-lg">
          GoodPlace Concierge
        </h3>
        <p className="text-white/80 text-sm">
          {isGoodWork
            ? 'Beschreibe, was du suchst - ich finde den passenden Arbeitsort'
            : 'Beschreibe, was du suchst - ich finde den passenden Ort fuer dich'}
        </p>
      </div>

      {/* Arrow */}
      <ArrowRight className="w-5 h-5 text-white/80 flex-shrink-0" />
    </button>
  );
}

export default ConciergeBanner;
